import { ReactNode } from 'react';
import { Cell } from '@tanstack/react-table';

import { Td, TdProps } from '@oaknorth/component-core-v2';

import { horizontalPinningProps } from '../horizontalPinning';

export type TableCellProps<T, V = unknown> = TdProps & {
  /**
   * Cell object based on react-table
   */
  cell: Cell<T, V>;
  /**
   * React Elements rendered inside <td>
   */
  children?: ReactNode;
};

export const TableCell = <T, V = unknown>({ cell, children, ...props }: TableCellProps<T, V>) => {
  const { isNumeric, isPinnedHorizontal } = cell.column.columnDef.meta || {};
  const pinnedProps: TdProps = isPinnedHorizontal ? horizontalPinningProps : {};
  return (
    <Td isNumeric={isNumeric} width={`${cell.column.getSize()}px`} {...pinnedProps} {...props}>
      {children}
    </Td>
  );
};
